(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schylling-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.schylling-site-header').forEach((section) => {
      const toggle = section.querySelector('[data-drawer-toggle]');
      const close = section.querySelector('[data-drawer-close]');
      const drawer = section.querySelector('.schylling-site-header__drawer');

      if (!toggle || !drawer || section.dataset.drawerBound === 'true') return;
      section.dataset.drawerBound = 'true';

      const setOpen = (open) => {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          drawer.hidden = false;
          section.dataset.drawerOpen = 'true';
        } else {
          drawer.hidden = true;
          section.dataset.drawerOpen = 'false';
        }
      };

      toggle.addEventListener('click', () => {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      if (close) {
        close.addEventListener('click', () => setOpen(false));
      }

      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) setOpen(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
